import {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from 'react';
import { RawConfirmDialog } from './InfoDialog';

const ConfirmDialog = createContext();

export function ConfirmDialogProvider({ children }) {
  const [state, setState] = useState({ dialogOpen: false });
  const fn = useRef();

  const confirm = useCallback(
    (data) => {
      return new Promise((resolve) => {
        setState({ ...data, dialogOpen: true });
        fn.current = (choice) => {
          resolve(choice);
          setState({ dialogOpen: false });
        };
      });
    },
    [setState]
  );

  return (
    <ConfirmDialog.Provider value={confirm}>
      {children}
      <RawConfirmDialog 
        {...state}
        hideOpenButton={true}
        okButtonFunc={() => fn.current(true)}
        cancelButtonFunc={() => fn.current(false)}
        onClose={() => fn.current(false)}
        />
    </ConfirmDialog.Provider>
  );
}

export default function useConfirm() {
  return useContext(ConfirmDialog);
}